module.exports = __webpack_public_path__ + "media/images/icons/icon-copied-e44f73aec497557c88b543422b181c6b.svg";